import React from 'react';

export function clamp(n: number, min: number, max: number) {
  return Math.min(max, Math.max(min, n));
}
export function easeOutCubic(t: number) {
  return 1 - Math.pow(1 - t, 3);
}
export function useAnimatedNumber(target: number, duration: number) {
  const [val, setVal] = React.useState(target);
  const rafRef = React.useRef<number | null>(null);
  const startRef = React.useRef<number | null>(null);
  const fromRef = React.useRef(target);
  React.useEffect(() => {
    fromRef.current = val;
    startRef.current = null;
    const step = (ts: number) => {
      if (startRef.current == null) startRef.current = ts;
      const p = Math.min(1, (ts - startRef.current) / duration);
      const eased = easeOutCubic(p);
      const next = fromRef.current + (target - fromRef.current) * eased;
      setVal(Math.round(next));
      if (p < 1) rafRef.current = requestAnimationFrame(step);
    };
    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(step);
    return () => rafRef.current && cancelAnimationFrame(rafRef.current);
  }, [target, duration]);
  return val;
}
